import axios from 'axios'
import API from '@/common/api'
import store from '..'

export default {
  namespaced: true,
  state: {
    type: [],
    list: []
  },
  mutations: {
  },
  actions: {
    setLocalList ({ state }, data) {
      state.list = data
    },
    async getLocalInfoType ({ state }) {
      try {
        const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=get-local-info-category`)
        // 200907 제외 타입 추가
        const filter = ['bar', 'spa']
        const filteredType = state.type = res.data.message.filter(x => !filter.includes(x))
        return filteredType
      } catch (ex) {
        return ex.response.data
      }
    },
    async getInfoSimple ({ state, rootState }, status) {
      const metaInfo = rootState.authentication
      const ota = store.state.authentication.public ? await store.dispatch('authentication/getOtaKey') : metaInfo.k
      try {
        const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=get-ad-info-simple&siteid=${API.SITE_INFO.site}&status=${status}&metakey=${metaInfo.metakey}&ota=${ota}`)
        return res.data.message
      } catch (ex) {
        return ex
      }
    },
    async getLocalList ({ state, dispatch }, infotype) {
      if (state.list.length === 0) {
        const type = typeof (infotype) === 'undefined' ? 'all' : infotype
        try {
          const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=get-local-info&siteid=${API.SITE_INFO.site}&type=${type}`)
          dispatch('setLocalList', res.data.message)
          return res.data.message
        } catch (ex) {
          return ex.response.data
        }
      }
    },
    async getSitePhotos ({ dispatch }, img) {
      try {
        const res = await axios.get(`https://google-map-photos.s3.ap-northeast-2.amazonaws.com/${img}`)
        return res
      } catch (ex) {
        return ex.response.data
      }
    }
  },
  getters: {
    getLocalType: state => {
      const realtype = state.list.map(x => x.siteType)
      return state.type.filter(x => realtype.includes(x))
    },
    getLocalList: state => state.list,
    getLocalInfo: state => placeId => {
      return state.list.find(x => x.placeId === placeId)
    }
  }
}
